module.exports = __webpack_public_path__ + "static/Graphik-Medium-4a127c955329def8ac32316e4c6b55a5.otf";